import { useEffect, useState } from "react";
import styled from "styled-components";
import ErrorMessage from "../Components/ErrorMessage";
import InputBoxTrans from "../Components/InputBoxTrans";
import { LogoRegister } from "../Components/LogoRegister.jsx";
import EmailInvisibleEx from "../Images/emailInvisible_ex.png";
import EmailVisibleEx from "../Images/emailVisible_ex.png";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import logoEx from "../Images/logoEx.png";
import LogoExTrans from "../Images/logoEx_Trans.png";
import LogoExCustom from "../Images/logoEx_custom.png";
import LogoExNotTrans from "../Images/logoEx_notTrans.png";
import "../Styles/fonts.css";
import "../Styles/global.css";

import { useNavigate } from "react-router-dom";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import RadioButton from "../Components/RadioButton";
import { postFormData } from "../Utils/apiUtils.js";
import ProgressBar from "../Components/ProgressBar.jsx";
import ProfileCard from "../Components/ProfileCard.jsx";
import { setCompanyName } from "../Utils/sessionUtils.js";

const InitUser = () => {
  const [step, setStep] = useState(1);
  const [logoVisibleType, setLogoVisibleType] = useState(null);
  const [appImage, setAppImage] = useState(null);
  const [nameKr, setNameKr] = useState(null);
  const [nameEn, setNameEn] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [logoImage, setLogoImage] = useState(null);
  const [emailVisible, setEmailVisible] = useState(0);
  const isEmailVisible = emailVisible === 0 ? 1 : 0;

  const navigate = useNavigate();

  const handleStep4AndComplete = async (departmentVisible) => {
    try {
      const formData = new FormData();
      formData.append("image", logoImage);
      formData.append("appImage", appImage);
      formData.append("companyName", companyName);
      formData.append("logoVisibleType", logoVisibleType);
      formData.append("logoNameKr", nameKr);
      formData.append("logoNameEn", nameEn);
      formData.append("isEmailVisible", isEmailVisible);
      formData.append("isDepartmentVisible", departmentVisible);

      const data = await postFormData(
        "/dashboard/company/createCompanyInfo2",
        formData,
        navigate
      );

      if (data.code === 200) {
        setCompanyName(companyName);
        localStorage.setItem("departmentVisible", departmentVisible);
        navigate("/home");
      }
    } catch (error) {
      console.error("기업정보설정 중 에러: ", error);
      throw error;
    }
  };

  const handleStep1Values = (company_name, logo_image) => {
    setCompanyName(company_name);
    setLogoImage(logo_image);
    setStep(2);
  };

  const handleStep2Values = (logoVisibleType, name1, name2, appImage) => {
    setLogoVisibleType(logoVisibleType + 1);
    setNameKr(name1);
    setNameEn(name2);
    setAppImage(appImage);
    setStep(3);
  };

  const handleStep3AndComplete = (emailVisible) => {
    localStorage.setItem("emailVisible", emailVisible === 0 ? true : false);
    setStep(4);
  };

  return (
    <div className="page-wrapper center" style={{ height: "1121px" }}>
      {step === 1 && (
        <Step1
          step={step}
          onStep1Complete={(name, logo) => handleStep1Values(name, logo)}
        />
      )}
      {step === 2 && (
        <Step2
          nameKr={nameKr}
          setNameKr={setNameKr}
          nameEn={nameEn}
          setNameEn={setNameEn}
          step={step}
          onStep2Complete={(logoVisibleType, name1, name2, appImage) =>
            handleStep2Values(logoVisibleType, name1, name2, appImage)
          }
        />
      )}
      {step === 3 && (
        <Step3
          step={step}
          emailVisible={emailVisible}
          setEmailVisible={setEmailVisible}
          onStep3AndComplete={(emailVisible) =>
            handleStep3AndComplete(emailVisible)
          }
        />
      )}
      {step === 4 && (
        <Step4 step={step} onStep4Complete={handleStep4AndComplete} />
      )}
    </div>
  );
};

const Step1 = ({ step, onStep1Complete }) => {
  const [error_message, setError_message] = useState("");
  const [value_companyName, setValue_companyName] = useState("");

  const handleInput_companyName = (value, message) => {
    setError_message(message);
    if (!message) {
      setValue_companyName(value);
    }
  };

  const isButtonEnabled = value_companyName;

  return (
    <InitBox>
      <ProgressBar step={step} />
      <h1 style={{ marginTop: "34px" }}>반가워요!✋</h1>
      <p className="reg-20-black" style={{ marginTop: "8px" }}>
        시작하기 전에 대시보드 초기 세팅을 위한
      </p>
      <p className="reg-20-black">기업정보를 입력해주세요</p>
      <p style={{ color: "#888888", marginTop: "8px" }}>
        설정한 정보는 나중에 변경할 수 있어요!
      </p>

      <div style={{ marginTop: "30px" }}>
        <InputBoxTrans
          message="기업명 입력*"
          type="companyName"
          handleInput={(value, message) =>
            handleInput_companyName(value, message)
          }
          code={200}
        />
        {error_message && <ErrorMessage message={error_message} />}
      </div>

      <div
        onClick={
          isButtonEnabled ? () => onStep1Complete(value_companyName) : null
        }
        style={{
          marginTop: "40px",
          cursor: isButtonEnabled ? "pointer" : "not-allowed",
        }}
      >
        <div
          className="blueBtn-base"
          style={{
            width: "400px",
            height: "56px",
            borderRadius: "10px",
            backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
          }}
        >
          다음
        </div>
      </div>
    </InitBox>
  );
};

const Step2 = ({
  nameKr,
  nameEn,
  setNameEn,
  setNameKr,
  step,
  onStep2Complete,
}) => {
  const [isCustom, setIsCustom] = useState(0);
  const [appLogo, setAppLogo] = useState(null);

  const handleOptionChange = (optionNum) => {
    setIsCustom(optionNum);
  };

  const [isButtonEnabled, setIsButtonEnabled] = useState(
    isCustom === 0 ? true : isCustom === 1 ? nameKr && nameEn : appLogo
  );

  useEffect(() => {
    setIsButtonEnabled(
      isCustom === 0 ? true : isCustom === 1 ? nameKr && nameEn : appLogo
    );
  }, [nameKr, nameEn, isCustom, appLogo]);

  useEffect(() => {
    setAppLogo(null);
  }, [isCustom]);

  return (
    <InitBox>
      <ProgressBar step={step} />
      <h1 style={{ marginTop: "34px" }}>
        앱 화면에 우리 기업을 어떻게 노출할까요?
      </h1>
      <p className="reg-20-black" style={{ marginTop: "8px" }}>
        랭킹마라톤 기업모드 앱 화면 좌측 상단에 노출할 기업명을 설정해주세요.
      </p>
      <p style={{ color: "#888888", marginTop: "8px" }}>
        설정한 정보는 나중에 변경할 수 있어요!
      </p>

      <RadioButtonBox>
        <RadioButton
          option1="기본"
          option2="기업명 입력"
          option3="로고 이미지"
          selectedOption={isCustom}
          optionChange={handleOptionChange}
        />
        {isCustom === 0 ? (
          <div>
            <p
              className="center"
              style={{ marginTop: "30px", marginBottom: "30px" }}
            >
              기본 로고와 ‘기업모드’ 텍스트가 노출됩니다.
            </p>
            <img src={logoEx} />
          </div>
        ) : isCustom === 1 ? (
          <div>
            <p
              className="center"
              style={{ marginTop: "30px", marginBottom: "30px" }}
            >
              기본 로고와 함께 노출되는 텍스트를 커스텀하세요.
            </p>
            <img src={LogoExCustom} />

            <p style={{ marginTop: "30px", marginBottom: "8px" }}>
              국내 기업명*
            </p>
            <InputBoxDisableTrans
              type="companyName"
              message="ex) 랭킹마라톤"
              handleInput={(value) => setNameKr(value)}
              setError_message={null}
              $hasError={false}
            />

            <p style={{ marginTop: "18px", marginBottom: "8px" }}>
              해외 기업명*
            </p>
            <InputBoxDisableTrans
              type="companyName"
              message="ex) Ranking"
              handleInput={(value) => setNameEn(value)}
              setError_message={null}
              $hasError={false}
            />
            <div style={{ marginTop: "8px", display: "flex" }}>
              <IconInfo fill="#b0b0b0" />
              <p
                style={{
                  marginLeft: "6px",
                  fontSize: "14px",
                  color: "#888888",
                }}
              >
                국내/해외 각 앱 메인화면에 노출될 기업명을 설정해주세요.
                <br />
                해외 기업명은 지원하는 모든 해외 국가에 공통적으로 노출됩니다.
              </p>
            </div>
          </div>
        ) : (
          <div>
            <p
              style={{
                fontSize: "16px",
                color: "#f25c5c",
                marginTop: "30px",
              }}
              className="medium-text center"
            >
              *규격 : 560 x 136px / 배경 투명화 필수
            </p>
            <LogoRegister
              onSetLogo={(file) => setAppLogo(file)}
              step={"step2"}
              previewLogo={appLogo}
            />
            <div style={{ height: "30px" }} />
            <p>ex{")"} 배경 투명화 미적용 시</p>
            <img src={LogoExNotTrans} style={{ margin: "8px 0px" }} />
            <p>ex{")"} 배경 투명화 적용 시</p>
            <img src={LogoExTrans} style={{ margin: "8px 0px" }} />

            <div style={{ display: "flex" }}>
              <IconInfo fill="#b0b0b0" />
              <p
                style={{
                  marginLeft: "6px",
                  fontSize: "14px",
                  color: "#888888",
                }}
              >
                지정된 규격의 투명화된 파일을 업로드해주세요.
                <br />
                사이즈가 상이하면 이미지가 깨질 가능성이 있습니다.
                <br />
                참조{")"} 배경색 #00EF89
              </p>
            </div>
          </div>
        )}
      </RadioButtonBox>

      <div
        onClick={
          isButtonEnabled
            ? () => onStep2Complete(isCustom, nameKr, nameEn, appLogo)
            : null
        }
        style={{
          marginTop: "40px",
          cursor: isButtonEnabled ? "pointer" : "not-allowed",
        }}
      >
        <div
          className="blueBtn-base"
          style={{
            width: "400px",
            height: "56px",
            borderRadius: "10px",
            backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
          }}
        >
          다음
        </div>
      </div>
    </InitBox>
  );
};

const Step3 = ({ emailVisible, setEmailVisible, step, onStep3AndComplete }) => {
  return (
    <InitBox>
      <ProgressBar step={step} />
      <h1 style={{ marginTop: "34px" }}>
        구성원의 이메일 정보 노출 여부를 설정해주세요.
      </h1>
      <p style={{ color: "#f25c5c", marginTop: "8px" }}>
        설정한 정보는 나중에 변경할 수 없습니다.
      </p>

      <RadioButtonBox>
        <RadioButton
          option1="이메일 노출"
          option2="이메일 비노출"
          selectedOption={emailVisible}
          optionChange={(num) => setEmailVisible(num)}
        />
        <div style={{ width: "556px", margin: "30px 0px" }}>
          <p className="center">
            ‘이메일 노출’ 시 회원정보 페이지에 각 회원의 기업 이메일이
            노출됩니다.
          </p>
          <p className="center">
            ‘이메일 비노출’ 시 이벤트성 연락이 어려워 질 수 있습니다.
          </p>
        </div>
        <div style={{ width: "443px" }}>
          {emailVisible == 0 ? (
            <img src={EmailVisibleEx} style={{ width: "443px" }} />
          ) : (
            <div className="center">
              <img src={EmailInvisibleEx} style={{ height: "104px" }} />
            </div>
          )}
        </div>
      </RadioButtonBox>

      <div
        onClick={() => onStep3AndComplete(emailVisible)}
        style={{
          marginTop: "40px",
          cursor: "pointer",
        }}
      >
        <div
          className="blueBtn-base"
          style={{
            width: "400px",
            height: "56px",
            borderRadius: "10px",
            backgroundColor: "#1167ed",
          }}
        >
          다음
        </div>
      </div>
    </InitBox>
  );
};

const InitBox = styled.div`
  width: auto;
  height: auto;
  font-family: "notoSans";

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > h1 {
    font-size: 30px;
    font-weight: bold;
    color: #000000;
    margin: 0;
  }
  .reg-20-black {
    font-family: "notoSans";
    font-size: 20px;
    color: #000000;
  }
  .info {
    margin-right: auto;
    display: flex;
    flex-direction: row;
    margin-top: 8px;
  }
  .infotext {
    margin-left: 4px;
    margin-top: 0;
    color: #888888;
    font-size: 15px;
  }
`;

const RadioButtonBox = styled.div`
  width: 561px;
  margin-top: 30px;
  padding: 30px 0px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px #c6d9f5;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default InitUser;

export const Step4 = ({ step, onStep4Complete }) => {
  const [departmentVisible, setDepartmentVisible] = useState(0);
  return (
    <>
      <ProgressBar step={step} />
      <h1 style={{ margin: "34px 0 8px", fontSize: "30px" }}>
        앱 내 구성원 닉네임을 어떻게 표시할까요?{" "}
      </h1>
      <p style={{ color: "#888888" }}>설정한 정보는 나중에 변경할 수 있어요!</p>
      <ContentWrapper>
        <ContentLayout>
          <RadioButton
            option1={"닉네임만 표시"}
            option2={"부서+닉네임으로 표시"}
            selectedOption={departmentVisible}
            optionChange={(option) => {
              setDepartmentVisible(option);
            }}
          />
          <div>
            {departmentVisible === 0 && <ProfileCard nickname={"홍길동"} />}
            {departmentVisible === 1 && (
              <ProfileCard department={"개발팀"} nickname={"홍길동"} />
            )}
            <p style={{ color: "#888888", marginTop: "20px" }}>
              ‘구성원 관리 &gt; 부서 관리’에서 부서명을 등록해주세요!{" "}
            </p>
          </div>
        </ContentLayout>
      </ContentWrapper>

      <div
        className="blueBtn-base center"
        style={{
          width: "500px",
          height: "56px",
          borderRadius: "10px",
          backgroundColor: "#1E4FFF",
        }}
        onClick={() => onStep4Complete(departmentVisible)}
      >
        시작하기
      </div>
    </>
  );
};

const ContentWrapper = styled.div`
  border-radius: 10px;

  background: #fff;
  margin: 30px 0;

  padding: 30px;
`;

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 24px 88.5px;
  border-radius: 20px;
  background: #f9f9f9;
`;
